import React from 'react'
import { graphql, Link } from 'gatsby';
import Container from '../../components/Container/Container';
import './Project-Template.scss';
import Contact from '../../components/Contact/Contact';
import { IoMdArrowRoundBack } from 'react-icons/io';

const project_template = ({ data:{project:{description, title, id, languages, content}, site:{siteMetadata:{author}}} }) => {
    
    return (
        <div className='project_template'>
            <Container>
                <div className='project_template_inner'>
                <div className='titleContainer'>
                    <Link to='/#projects' ><IoMdArrowRoundBack className='icon'/></Link>
                    <h1 className='title'>{title}</h1> 
                </div>
                <p className='createdAt'>Designed/Developed By: {author}</p>
                <div className='overview'>
                    <h3>Overview</h3>
                    <p>{description}</p>
                </div>
                <div className='content' dangerouslySetInnerHTML={{__html: content.childMarkdownRemark.html}}>
                </div>
                <div className='footer'>
                <Contact />
                <p>Designed and Developed by Philane Msibi. { new Date().getFullYear() }</p>
                </div>
                </div>
                
            </Container>
        </div>
    )
}

export const result = graphql`
query GetProject($slug: String) {
    project:contentfulProjects(slug: {eq: $slug}) {
      title
      id
      description
      languages
      slug
      content {
        childMarkdownRemark {
          html
        }
      }
    }
    site {
      siteMetadata {
        author
      }
    }
  }
`

export default project_template
